export enum PermissionType {
    EMAILNOTIFICATION = 'EmailNotification',
    SMSNOTIFICATION = 'SmsNotification',
    FOLDEREXCEPTDELETE = 'FolderExceptDelete',
    FOLDERDELETE = 'FolderDelete',
    SETMESSAGEREAD = 'SetMessageRead',
    SETMESSAGFLAG = 'SetMessageFlag',
    SETLEGALLYNOTIFIEDTOTRUE = 'SetLegallyNotifiedToTrue',
    SAVEDRAFT = 'SaveDraft',
    MOVEMESSAGEBETWEENFOLDERS = 'MoveMessageBetweenFolders',
    MOVEMESSAGETOBIN = 'MoveMessageToBin',
    DELETEBIN = 'DeleteBin',
    SENDMESSAGE = 'SendMessage',
    FORWARDTOEMAIL = 'ForwardToEmail',
    FORWARDTONGDPIDENTITY = 'ForwardToNgdpIdentity',
}
